import { render, staticRenderFns } from "./PageValidators.vue?vue&type=template&id=73156dc0"
import script from "./PageValidators.vue?vue&type=script&lang=js"
export * from "./PageValidators.vue?vue&type=script&lang=js"
import style0 from "./PageValidators.vue?vue&type=style&index=0&id=73156dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports